import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface CachePollModel {
    id: string;
    productCode: string;
    nextCacheRefresh: string;
    createdBy: string;
    createdOn: string;
}

@Injectable({
    providedIn: 'root'
})
export class CacheService {
    private baseUrl = `${environment.apiURL}/cache`; // Adjust base URL as needed

    constructor(private _httpClient: HttpClient) { }

    getCacheByProductCode(): Observable<CachePollModel> {
        return this._httpClient.get<CachePollModel>(`${this.baseUrl}/get`);
    }

    flushCache(): Observable<string> {
        return this._httpClient.post<string>(`${this.baseUrl}/flush`, {});
    }
}
